/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingBillsItem from './ListingBillsItem';

import './ListingBills.scss';

const groupBills = bills =>
  bills.reduce((memory, current) => {
    const { key, value } = current;
    const isGlobal = value.includes('Global');
    if (!isGlobal) {
      return [...memory, current];
    }
    const existingItem = memory.find(item => item.value === current.value);
    if (!existingItem) {
      return [...memory, { ...current, key: [key] }];
    }
    return memory.map(item =>
      item === existingItem ? { ...item, key: [...item.key, key] } : item
    );
  }, []);

const ListingBills = ({
  bills = [],
  currency,
  listingType,
  showTitle = true
}) => (
  <div className="bill-description__title__wrapper">
    {showTitle ? (
      <div className="bill-description__title">
        <span>{trans('listing.bills.title')}</span>
      </div>
    ) : null}
    {groupBills(bills).map(bill => (
      <ListingBillsItem
        key={bill.key}
        bill={bill}
        listingType={listingType}
        currency={currency}
      />
    ))}
  </div>
);

ListingBills.propTypes = {
  showTitle: PropTypes.bool,
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      additionalInfo: PropTypes.number
    })
  ),
  currency: PropTypes.string.isRequired,
  listingType: PropTypes.string.isRequired
};

export default ListingBills;
